import React, {FC, useState} from "react";
import {hasPermission} from "../../../../helpers/utils/AccessControlUtils";
import {handleEnterKey, showToast} from "../../../../helpers/utils/Utils";
import ConfirmationModal from "../../../../components/layout/modal/ConfirmationModal";
import InputField from "../../../../components/common/form/InputField";
import NumberFormatField from "../../../../components/common/form/NumberFormatField";
import SubdivisionListModal from "../Common/Modals/SubdivisionListModal";


interface HoaInfoSectionProps {
    curAccount?: any;
    accounts?: any;
    setAccounts?: any;
    certificate?: any;
    showAccount?: any;
    listCounty?: any;
    setReset?: any;
    checkBox?: any;
    setCheckBox?: any;
    sudDivisionData?: any;
    editable?: boolean;
    setIsEmptyState?: any;
    setIsEmptyCounty?: any;
    setUpdatedAccountIndexList?: any;
    authorities?: any[];
    getSubdivisionByNameAndCountyApi?: any;
}

const HoaInfoSection: FC<HoaInfoSectionProps> = ({
                                                     curAccount,
                                                     setAccounts,
                                                     certificate,
                                                     showAccount,
                                                     listCounty,
                                                     setReset,
                                                     checkBox,
                                                     setCheckBox,
                                                     sudDivisionData,
                                                     editable,
                                                     setIsEmptyState,
                                                     setIsEmptyCounty,
                                                     setUpdatedAccountIndexList,
                                                     getSubdivisionByNameAndCountyApi
                                                 }) => {

    const [confirmationModal, setConfirmationModal] = useState(false);
    const [showSubdivision, setShowSubdivision] = useState(false);
    const [disable, setDisable] = useState(false);

    function updateSubdivision(e: React.FormEvent) {
        e.preventDefault();
        setDisable(false);
        setConfirmationModal(false);
        curAccount['taxDataSource'] = 'EDITOR';
        setUpdatedAccountIndexList((prev:any) => {
            if (!prev.includes(showAccount)) {
                return [...prev, showAccount];
            }
            return prev;
        });
        setReset(true);
    }

    return (
        <>
            <div className="col-lg-6 col-sm-12 pl-0">
                <div className="border border-solid border-text-4 bg-highlight-1 text-[white] p-2  ">
                    <b className="weight_data">HOA Information</b>
                </div>
                <div className="border border-solid border-text-4">
                    <table
                        className="scroll1 tax-table text-sm w-full [&_td]:border [&_td]:border-surface-5 p-[6px] text-left">
                        <tbody className="table-striped text-sm">
                        <tr>
                            <td className="pl-3">Subdivision
                                {hasPermission(["SUBD-V"]) && (
                                    <span>
                                            <a href={(curAccount === undefined || curAccount['subdivisionId'] == null || curAccount['subdivisionId'] === "") ? '/subdivisions' : '/subdivisions/' + curAccount['subdivisionId']}
                                               target={"_blank"}>
                                                <i className="fa fa-link ml-2 text-highlight-4" aria-hidden="true"/>
                                            </a>
                                        </span>
                                )}
                            </td>
                            <td style={{position: "relative"}}>
                                <InputField
                                    placeholder="Select Subdivision..."
                                    hideLabel
                                    name="Collector"
                                    value={curAccount?.subdivisionDTO?.subdivisionKey?.name || ""}
                                    type="text"
                                    inputIcon={
                                        <span className={"absolute top-[20px] right-3 "}>
                                                {(curAccount?.subdivisionId != null && curAccount['subdivisionId'] !== "") && editable && (
                                                    <i
                                                        onClick={(e: React.MouseEvent) => {
                                                            e.preventDefault();
                                                            const updatedAccount = {
                                                                ...curAccount,
                                                                taxDataSource: 'EDITOR',
                                                            };
                                                            getSubdivisionByNameAndCountyApi({
                                                                name: curAccount['subdivisionDTO']?.subdivisionKey?.name.split('PH')[0].split('SEC')[0].trim(),
                                                                countyId: curAccount['countyId'],
                                                                targetCerts: ["BOTH", "HOA"],
                                                                id: curAccount['subdivisionId'],
                                                                accountNumber: curAccount['accountNumber']
                                                            })
                                                            setAccounts(updatedAccount);
                                                        }}
                                                        className={sudDivisionData?.isFetching
                                                            ? "fas fa-sync fa-spin ml-xl-n4 absolute left-auto right-8  text-highlight-1 search_span  mr-4 pr-2"
                                                            : "fa fa-refresh cursor-pointer absolute left-auto right-8  text-highlight-1 search_span"}
                                                        aria-hidden="true"
                                                    />
                                                )}

                                            <i
                                                onClick={(e: React.MouseEvent) => {
                                                    e.preventDefault();
                                                    if (editable) {
                                                        if (curAccount?.subdivisionId) {
                                                            setConfirmationModal(true);
                                                        } else {
                                                            if (curAccount?.stateId && curAccount?.countyId) {
                                                                setShowSubdivision(true);
                                                            } else {
                                                                if (!curAccount?.stateId) setIsEmptyState(true);
                                                                else setIsEmptyState(false);
                                                                if (!curAccount?.countyId) setIsEmptyCounty(true);
                                                                else setIsEmptyCounty(false);
                                                                showToast("Please ensure that State and County are defined", "error");
                                                            }
                                                        }
                                                    }
                                                }}
                                                className={curAccount?.subdivisionId ? "fa fa-times ml-xl-n4 search_span absolute left-auto right-2  text-highlight-1" : "fa fa-search ml-xl-n4 collector-account-modal search_span text-highlight-1"}
                                            />
                                            </span>
                                    }
                                    disabled={true}
                                    baseClass={false}
                                />


                            </td>
                        </tr>
                        {/* Association Row */}
                        <tr>
                            <td className="pl-3">Association
                                {hasPermission(["ASSOC-V"]) && (
                                    <span>
                                            <a href={(curAccount?.associationName == null || curAccount?.associationName === "") ? '/associations' : '/associations/' + curAccount['associationId']}
                                               target={"_blank"}>
                                                <i className="fa fa-link ml-2 text-highlight-4" aria-hidden="true"/>
                                            </a>
                                        </span>
                                )}
                            </td>
                            <td className="relative">
                                <InputField
                                    placeholder="..."
                                    value={curAccount?.associationName || ''}
                                    type="text"
                                    disabled={true}
                                    hideLabel
                                    baseClass={false}

                                />
                                {sudDivisionData?.isFetching && <span>
                                        <i className={"fas fa-sync fa-spin ml-xl-n4 text-highlight-1 search_span absolute right-6 top-7"}
                                           aria-hidden="true"/>
                                    </span>}
                            </td>
                        </tr>
                        {/* Management Row */}
                        <tr>
                            <td className="pl-3">
                                <div className={"d-flex"}>
                                    Management
                                    {hasPermission(["MGTCOM-V"]) && (
                                        <span>
                                                <a href={(curAccount?.managementCompany?.name == null || curAccount?.managementCompany?.name === "") ? '/management-companies' : '/management-companies/' + curAccount['managementCompany']['managementCompanyId']}
                                                   target={"_blank"}>
                                                    <i className="fa fa-link ml-2 text-highlight-4" aria-hidden="true"/>
                                                </a>
                                            </span>
                                    )}
                                </div>
                            </td>
                            <td className="relative">
                                <InputField
                                    placeholder="..."
                                    value={curAccount?.managementCompany?.name || ''}
                                    type="text"
                                    disabled={true}
                                    hideLabel
                                    baseClass={false}

                                />
                                {sudDivisionData?.isFetching && <span>
                                        <i className={"fas fa-sync fa-spin ml-xl-n4 text-highlight-1 search_span absolute right-6 top-7"}
                                           aria-hidden="true"/>
                                    </span>}
                            </td>
                        </tr>
                        {/* Third Party Provider Row */}
                        <tr className="separation_line">
                            <td className="pl-3">
                                <div className={"d-flex"}>
                                    Third Party Provider
                                    {hasPermission(["HOATPP-V"]) && (
                                        <span>
                                                <a href={(curAccount?.thirdPartyProviderId == null || curAccount?.thirdPartyProviderId === "") ? '/third-party-providers' : '/third-party-providers/' + curAccount['thirdPartyProviderId']}
                                                   target={"_blank"}>
                                                    <i className="fa fa-link ml-2 text-highlight-4" aria-hidden="true"/>
                                                </a>
                                            </span>
                                    )}
                                </div>
                            </td>
                            <td className="relative">
                                <InputField
                                    placeholder="..."
                                    className="form-control"
                                    value={curAccount?.thirdPartyProviderName || ''}
                                    type="text"
                                    disabled={true}
                                    hideLabel
                                    baseClass={false}

                                />
                                {sudDivisionData?.isFetching && <span>
                                        <i className={"fas fa-sync fa-spin ml-xl-n4 text-highlight-1 search_span absolute right-6 top-7"}
                                           aria-hidden="true"/>
                                    </span>}
                            </td>
                        </tr>

                        {/* Continue adding similar rows for the remaining fields */}
                        <tr>
                            <td className="pl-3">Name</td>
                            <td className="relative">
                                <InputField
                                    placeholder="..."
                                    value={curAccount?.managementCompany?.contactName || ''}
                                    type="text"
                                    disabled={true}
                                    hideLabel
                                    baseClass={false}

                                />
                                {sudDivisionData?.isFetching && <span>
                                        <i
                                            className={"fas fa-sync fa-spin ml-xl-n4 text-highlight-1 search_span absolute right-6 top-7"}
                                            aria-hidden="true"/>
                                    </span>}
                            </td>
                        </tr>
                        <tr>
                            <td className="pl-3">Address</td>
                            <td className="relative">
                                <InputField
                                    placeholder="..."
                                    value={curAccount?.managementCompany?.address.mailingAddress || ''}
                                    type="text"
                                    disabled={true}
                                    hideLabel
                                    baseClass={false}

                                />
                                {sudDivisionData?.isFetching && <span>
                                        <i
                                            className={"fas fa-sync fa-spin ml-xl-n4 text-highlight-1 search_span absolute right-6 top-7"}
                                            aria-hidden="true"/>
                                    </span>}
                            </td>
                        </tr>

                        <tr>
                            <td className="pl-3">City/State/Zip</td>
                            <td className="relative">

                                <div className={"d-flex"}>

                                    <div className="relative">
                                        <InputField
                                            placeholder="..."
                                            value={curAccount?.managementCompany?.address.city || ''}
                                            type="text"
                                            disabled={true}
                                            hideLabel
                                            baseClass={false}

                                        />
                                        {sudDivisionData?.isFetching && <span>
                                                <i className={"fas fa-sync fa-spin ml-xl-n4 text-highlight-1 search_span absolute right-4 top-5"}
                                                   aria-hidden="true"/>
                                            </span>
                                        }

                                    </div>

                                    <div className={"mr-2 ml-2 relative"}>
                                        <InputField
                                            placeholder="..."
                                            value={curAccount?.managementCompany?.address.state || ''}
                                            type="text"
                                            disabled={true}
                                            hideLabel
                                            baseClass={false}

                                        />
                                        {sudDivisionData?.isFetching && <span>
                                                <i className={"fas fa-sync fa-spin ml-xl-n4 text-highlight-1 search_span absolute right-4 top-5"}
                                                   aria-hidden="true"/>
                                            </span>}

                                    </div>


                                    <div className="relative">
                                        <InputField
                                            placeholder="..."
                                            value={curAccount?.managementCompany?.address.zipCode || ''}
                                            type="text"
                                            disabled={true}
                                            hideLabel
                                            baseClass={false}

                                        />
                                        {sudDivisionData?.isFetching && <span>
                                                <i className={"fas fa-sync fa-spin ml-xl-n4 text-highlight-1 search_span absolute right-4 top-5"}
                                                   aria-hidden="true"/>
                                            </span>}

                                    </div>

                                </div>


                            </td>
                        </tr>
                        <tr>
                            <td className="pl-3">Phone</td>
                            <td className="relative">
                                <NumberFormatField className="form-control" placeholder="Enter Phone..."
                                                   name="phone"
                                                   value={curAccount?.managementCompany?.phone || ""}
                                                   hidelabel={true}
                                                   disabled={true}
                                                   onChange={(e: any) => {
                                                       handleEnterKey(e)
                                                   }}

                                />

                                {sudDivisionData?.isFetching && <span>
                                        <i
                                            className={"fas fa-sync fa-spin ml-xl-n4 text-highlight-1 search_span absolute right-7 top-7"}
                                            aria-hidden="true"/>
                                    </span>}
                            </td>
                        </tr>

                        <tr>
                            <td className="pl-3">Email</td>
                            <td className="relative">
                                <InputField
                                    placeholder="..."
                                    value={curAccount?.managementCompany?.email || ''}
                                    type="text"
                                    disabled={true}
                                    hideLabel
                                />
                                {sudDivisionData?.isFetching && <span>
                                        <i
                                            className={"fas fa-sync fa-spin ml-xl-n4 text-highlight-1 search_span absolute right-7 top-7"}
                                            aria-hidden="true"/>
                                    </span>}
                            </td>
                        </tr>

                        <tr>
                            <td className="pl-3">Website</td>
                            <td className="relative">
                                <InputField
                                    placeholder="..."
                                    value={curAccount?.managementCompany?.website || ''}
                                    type="text"
                                    disabled={true}
                                    hideLabel
                                />
                                {sudDivisionData?.isFetching && <span>
                                        <i
                                            className={"fas fa-sync fa-spin ml-xl-n4 text-highlight-1 search_span absolute right-7 top-7"}
                                            aria-hidden="true"/>
                                    </span>}
                            </td>
                        </tr>


                        </tbody>
                    </table>
                </div>
            </div>

            {showSubdivision && listCounty &&
                <SubdivisionListModal show={showSubdivision}
                                      setShow={setShowSubdivision}
                                      certificate={certificate} showAccount={showAccount}
                                      checkBox={checkBox}
                                      setCheckBox={setCheckBox}
                                      setDisable={setDisable}
                                      countyName={listCounty && listCounty?.find((cur: any) => cur.id === curAccount['countyId'])?.countyName}
                                      county={curAccount['countyId']}
                                      setUpdatedAccountIndexList={setUpdatedAccountIndexList}
                                      addParentAccountsForSubdivision={undefined}
                                      getSubdivisionByNameAndCountyApi={getSubdivisionByNameAndCountyApi}
                />}

            {confirmationModal && <ConfirmationModal title={"Warning"}
                                                     bodyMessage={<><p>Changing subdivision will reset fee list and
                                                         association
                                                         notes.</p><p>Continue ?</p></>}
                                                     onSubmit={updateSubdivision} show={confirmationModal}
                                                     setShow={setConfirmationModal}
                                                     isLoading={disable}
                                                     isHoa={true}
            />}
        </>
    );
};

export default HoaInfoSection;
